import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Checkbox, ConfigProvider, Dropdown, Flex, Row, Space, Table, Tag } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDate, formatDateTime } from "utils/formatter";

const PendingApprovalOffsiteWorkTable = ({
  modalFlag = true,
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onReturn = () => { },
  onApprove = () => { },
  onApproveAll = () => { },
  onRejectAll = () => { },
  onReject = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onChange = () => { },
  onOpenModal = () => { },
  pageType = ""
}) => {
  const { t, i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;

  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t("workin_location.label.approvalSequence")}</div>,
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      visible: !modalFlag,
      align: "center",
      render: (_, record, index) => {
        const getApprovalOrder = () => {
          let order = 1;
          if (record.children === null) {
            order = 1;
          } else if (record.children === undefined) {
            order = index + 2;
          } else {
            order = 1;
          }
          return `${t("workin_location.label.approvalNumber")} ${order}`;
        };

        return getApprovalOrder();
      },
    },
    {
      title: <div className="text-table">{t('name-surname')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: true,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.employee?.nameAndSurnameEn}</span> : <span>{record?.employee?.nameAndSurname}</span>
      }

    },
    {
      title: <div className="text-table">{t('workin_location.label.worktype')}</div>,
      dataIndex: "workType",
      key: "workType",
      visible: true,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.workType?.leaveTypeNameEn}</span> : <span>{record?.workType?.leaveTypeName}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.label.create-date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.createDate ? formatDate(record?.createDate) : "-"
      }
    },
    {
      title: <div className="text-table">{t('start-date')}</div>,
      dataIndex: "startDate",
      key: "startDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.startDate ? formatDate(record?.startDate) : "-"
      },
    },
    {
      title: <div className="text-table">{t('end-date')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.endDate ? formatDate(record?.endDate) : "-"
      },
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: "offsiteWorkDateTimeString",
      key: "offsiteWorkDateTimeString",
      visible: true,
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: "endDateTimeString",
      key: "endDateTimeString",
      visible: true,
      align: "center"
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: "offsiteWorkDateTimeString",
      key: "offsiteWorkDateTimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: "endDateTimeString",
      key: "endDateTimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t('leave_type.label.duration')}</div>,
      dataIndex: "duration",
      key: "duration",
      visible: true,
      align: "center",
      render: (_, record) => {
        if (record.durationType === 'ALLDAY') {
          return i18n.language === 'en' ? record?.totalDuration + " Day" : record?.totalDuration + " วัน"
        } else {
          return i18n.language === 'en' ? record?.totalDurationHour + "H " + record?.totalDurationMinute + "M" : record?.totalDurationHour + " ชม. " + record?.totalDurationMinute + " นาที"
        }
      }
    },
    // {
    //   title: <div className="text-table">{t('description.description')}</div>,
    //   dataIndex: "description",
    //   key: "description",
    //   visible: true,
    // },
    {
      title: <div className="text-table">{t('status.status')}</div>,
      dataIndex: "approveStatusEn",
      key: "approveStatusEn",
      align: "center",
      visible: true,
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />

        // let tagColor = "green";
        // if (record?.approveStatusEn === "Pending") {
        //   tagColor = "blue";
        // } else if (record?.approveStatusEn === "Rejected" || record?.approveStatusEn === "Cancelled") {
        //   tagColor = "red";
        // }
        // return i18n.language === 'en' ? <Tag color={tagColor}>{record?.approveStatusEn}</Tag> : <Tag color={tagColor}>{record?.approveStatus}</Tag>
      },
    },
    {
      title: <div className="text-table">{t('วันที่อนุมัติ')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      visible: !modalFlag,
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    {
      title: "",
      key: "action",
      align: "center",
      visible: modalFlag,
      width: "50px",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => { onOpenModal(record); },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "2",
                  onClick: () => onApprove({
                    ...record,
                    table: "PendingApprovalOffsiteWorkTable"
                  }),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "3",
                  onClick: () => onReject({
                    ...record,
                    table: "PendingApprovalOffsiteWorkTable"
                  }),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },

  ];

  const visibleColumns = columns.filter((col) => col.visible);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Flex vertical gap={16}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              selectionColumnWidth: "45px"
            },
          },
        }}
      >
        <TableAntd
          loading={isLoading}
          style={{ backgroundColor: "white", width: "100%" }}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              t("paginate.description")
                .replace("{min}", range[0])
                .replace("{max}", range[1])
                .replace("{total}", total),
          }}
          dataSource={processedDataSource}
          rowKey={(record) => record.id}
          columns={visibleColumns}
          onChange={onChange}
          scroll={{ x: true }}
          rowSelection={pageType === "view" ? rowSelection : undefined}
        />
      </ConfigProvider>

      {hasSelected && pageType === "view" &&
        (<Flex vertical gap={8} style={{ alignItems: "end" }}>
          <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
          <Row style={{ gap: "8px" }}>
            <Button
              type="default"
              style={{ borderRadius: "8px", height: "40px" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onRejectAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >
              {t("request_approval.label.not_approved")}</Button>
            <Button
              type="primary"
              style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onApproveAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >{t("request_approval.label.approve")}</Button>
          </Row>
        </Flex>)}
    </Flex>
  );
};

export default PendingApprovalOffsiteWorkTable;
